// src/layouts/AuthLayout.jsx
import mainstyle from "../style/Main.module.css";
import layoutstyle from "../style/layouts/RegisterLayout.module.css";
import images from "../utils/images";
import { logoutUser } from "../utils/localStorageUtils";
import webSocket from "../services/onlineSocketService";
import { logOut } from "../services/authService";
import { useNavigate } from "react-router-dom";

export const CompanyLayout = ({ children, imageUrl }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logOut();
    } catch (error) {
      console.error("Logout API failed", error);
    }

    webSocket.disconnect(); // Disconnect WebSocket
    logoutUser();
    // window.location.reload();

    navigate("/login");
  };
  return (
    <div className={mainstyle.maincontainer}>
      {/* Common Header */}
      {/* <header className="">
          <div className="">
            <img 
              src="/logo.svg" 
              alt="Company Logo" 
              className="" 
            />
            <nav>
              <a href="/login" className="">
                Already have an account? <span className="">Sign In</span>
              </a>
            </nav>
          </div>
        </header>
   */}
      {/* Split Screen Content */}
      <div className={layoutstyle.registerContainer}>
        {/* Image Side (Left) */}
        <div className={layoutstyle.registerSplit1}>
          <div
            className={layoutstyle.registerSplit1Img}
            style={{ backgroundImage: `url(${images.backGroundImg})` }}
          >
            {/* <img 
                src={images.backGroundImg} 
                alt="Authentication Illustration" 
                className=""
              /> */}
            <div className={layoutstyle.registerSplit1Content}>
              <p>
                "Create your team workspace on Chat App and streamline
                collaboration with instant messaging and effortless file
                sharing. Designed for productivity, our platform keeps your team
                connected and projects moving—all in one place. Sign up now and
                get your team started in minutes!"
              </p>
            </div>
          </div>
        </div>

        {/* Form Side (Right) */}
        <div className={layoutstyle.registerSplit2}>
          <header className={layoutstyle.registerHeader}>
            <span
              className={layoutstyle.registerHeaderspan}
              onClick={handleLogout}
              style={{ cursor: "pointer" }}
            >
              <p>Want to leave?</p>{" "}
              {/* <Link to="/signup" className={layoutstyle.registerHeaderSpanLink}> */}
              <p style={{ color: "green" }}>Signout</p>
              {/* </Link> */}
            </span>
          </header>
          <div className={layoutstyle.registerLayoutContent}>
            <div className={layoutstyle.registerLayoutContentsub}>
              <div className={layoutstyle.registerLayoutForm}>{children}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
